'use strict'

module.exports = require('./dist/random').default
